import React, { useState, useEffect } from "react";
import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import PropTypes from "prop-types";
import { tooltips, tooltiptextId } from "../../locales/en";
import "../../assets/scss/common.scss";

const ExpandToggle = ({ isExpanded, onToggle, id }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggle = (e) => {
    onToggle(e);
    if (e.currentTarget) {
      e.currentTarget.blur();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleToggle(e);
    }
  };

  return (
    <span
      tabIndex={0}
      className="expandbtn cursor-pointer"
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      data-tooltip-id={isMobile ? undefined : id || tooltiptextId.default}
      data-tooltip-content={
        isExpanded ? tooltips.showLessDetails : tooltips.showMoreDetails
      }
      style={{ outline: "none" }}
    >
      {isExpanded ? <FaMinusCircle /> : <FaPlusCircle />}
    </span>
  );
};

export default ExpandToggle;

ExpandToggle.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  id: PropTypes.string
};
